<template>
    <ModalTemplate @close="$emit('close')"> 
        <template v-slot:header>
            <div class="modal-switcher">
                <h4 class="modal-switcher__item" :class="{active: active === 'rate'}" @click="setActive('rate')">Рейтинг</h4>
                <h4 class="modal-switcher__item" :class="{active: active === 'codes'}" @click="setActive('codes')" v-if="itsYou">Промокоды</h4>
            </div>
        </template>
        <template v-slot:body>
            <div class="modal-rate">
                <div class="block-score" v-if="active === 'rate'">
                    <p class="block-score__title">«{{ score.level.name }}»</p>
                    <p class="block-score__text">{{ score.level.description }}</p>
                    <div class="growup-progress">
                            <div class="growup-avatar">
                                <img :src="require(`@/assets/images/emoji/${score.level.icon}.svg`)" width="40" />
                            </div>
                            <div class="growup-progress-line">
                                <div class="growup-progress-inside" :style="{width: `${getLineWidth}%`}">
                                    <p class="growup-progress__count">{{ score.sum }}</p>
                                </div>
                                <p class="growup-progress__count" v-if="getLineWidth < 80">{{ score.next.score }}</p>
                            </div>
                            <div class="growup-level" v-if="score.next">
                                <img :src="require(`@/assets/images/emoji/${ score.next.icon }.svg`)" width="24" />
                            </div>
                            <div class="growup-level" v-else>
                                <img src="@/assets/images/emoji/question.svg" width="34" />
                            </div>
                    </div>
                </div>
                <div class="block-promocodes" v-else>
                    <div class="promocodes" v-if="promocodes && promocodes.length > 0">
                        <div class="promocodes-group" v-for="(company, index) in companiesCodes" :key="index">
                            <h4 class="promocodes-group__title">{{ company.name }}</h4>
                            <div class="promocodes-group__body">
                                <Promocode 
                                    v-for="promocode in company.promocodes"
                                    :promocode="promocode"
                                    :key="promocode.id"
                                />
                            </div>
                        </div>
                    </div>
                    <p v-else-if="!loading" class="promocode-list__label">У вас пока нет промокодов, чтобы их получить - проявляй активность 😉.</p>
                    <Loader :color="'black'" v-if="loading" />
                </div>
            </div>
            <Loader :color="'red'" v-if="loading" />
        </template>

    </ModalTemplate>
</template>
<script>

export default {
    name: 'ModalScore',
    data: () => {
        return {
            loading: false,
            promocodes: null,
            active: 'rate'
        }
    },
    props: {
        score: {
            type: Object,
            require: true
        },
        itsYou: {
            type: Boolean,
            require: false
        },
        mode: {
            type: String,
            required: false,
            default: 'rate'
        }
    },
    components: {
        ModalTemplate: () => import('@/components/Templates/Modal'),
        Loader: () => import('@/components/UI/Loader'),
        Promocode: () => import('@/components/UI/Promocode'),
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        },
        getLineWidth() {
            console.log(this.score,'this.score');
            return this.score && this.score.new_level 
                ? 100
                : this.score.sum / (this.score.next.score / 100)
        },
        companiesCodes() {
            let result = [{name: 'Без компании', promocodes: []}];
            if (this.promocodes) {
                this.promocodes.forEach(promocode => {
                    let finded = result.find(company => company.name === promocode.company);
                    finded 
                        ? result[result.indexOf(finded)].promocodes.push(promocode)
                        : result.push({
                            name: promocode.company,
                            promocodes: [promocode]
                        });
                });
            }
            return result.filter(company => company.promocodes.length > 0)
        }
    },
    methods: {
        setActive(mode) {
            this.promocodes = null
            this.active = mode
            if (mode === 'codes') {
                this.getPromocodes()
            }
        },
        async getPromocodes() {
            this.loading = true
            await this.$axios.post('/api/promocodes')
            .then(res => {
                this.promocodes = res.data
            })
            .catch(() => {
                this.$store.dispatch('addError', {message: 'Произошла ошибка при загрузке промокодов'})
            })
            this.loading = false
        }
    },
    mounted() {
        this.active = this.mode
        this.mode === 'codes' ? this.getPromocodes() : ''
    }
}
</script>
<style lang="stylus">
.modal
    &-rate
        width 500px
        min-height 150px
        display flex
        flex-direction column
    
    &-switcher
        display flex
        align-items center
        padding-bottom 20px
        &__item
            font-size 20px
            margin-right 10px
            font-weight 600
            color #eaeaea
            transition 0.3s all
            cursor pointer
            &:hover
                color black
            &.active
                color black
    
    .growup-progress
        padding-top 30px

    .block
        &-score
            .growup-progress__count
                top 7px
            &__title
                font-size 18px
                font-weight 600
                padding-bottom 10px
            
            &__text
                font-size 16px
                font-weight 500
                line-height 20px
        
        &-promocodes
            display flex
.promocodes
    width 100%
    &-group
        padding-bottom 15px
        position relative
        width 100%
        &__body
            display flex
            flex-wrap wrap
        &:after
            content ''
            position absolute
            top 9px
            right 0
            height 2px
            background-color #eaeaea
            width 100%
        
        &__title
            padding-bottom 10px
            width fit-content
            padding-right 10px
            font-size 18px
            font-weight 600
            position relative
            z-index 2
            background-color white

</style>